import moment from 'moment-timezone';
import _ from 'lodash';
import config from '../config';

const { ALL_LANGUAGES } = config;

export const CTA_TEXT_MAX_LENGTH = 10;

export function validateAlert(alert, now = moment()) {
  const errors = {};
  const languageErrors = {};

  // Every tenant language is required, same as priority create.
  ALL_LANGUAGES.forEach((language) => {
    const copy = alert.languages?.[language] || {};
    const copyErrors = {};

    if (!_.trim(copy.headline)) {
      copyErrors.headline = 'Headline is required.';
    }

    if (!_.trim(copy.details)) {
      copyErrors.details = 'Details are required.';
    }

    if (alert.cta_enabled) {
      if (!_.trim(copy.cta_text)) {
        copyErrors.cta_text = 'Button text is required.';
      } else if (_.trim(copy.cta_text).length > CTA_TEXT_MAX_LENGTH) {
        copyErrors.cta_text = `Button text must be ${CTA_TEXT_MAX_LENGTH} characters or fewer.`;
      }

      if (!_.trim(copy.cta_link)) {
        copyErrors.cta_link = 'Link is required.';
      }
    }

    if (!_.isEmpty(copyErrors)) {
      languageErrors[language] = copyErrors;
    }
  });

  if (!_.isEmpty(languageErrors)) {
    errors.languages = languageErrors;
    errors.summary = 'You need to fill all the languages';
  }

  if (!alert.appearance) {
    errors.appearance = 'Select an urgency.';
  }

  // An empty start means "Immediately", so only a chosen start is checked.
  if (alert.start && !moment(alert.start).isValid()) {
    errors.start = 'Enter a valid start time.';
  } else if (alert.start && moment(alert.start).isBefore(now, 'minute')) {
    errors.start = 'Start time must be now or in the future.';
  }

  if (alert.end && !moment(alert.end).isValid()) {
    errors.end = 'Enter a valid end time.';
  } else if (alert.end && moment(alert.end).isSameOrBefore(now)) {
    errors.end = 'End time must be in the future.';
  } else if (
    alert.end &&
    alert.start &&
    moment(alert.end).isSameOrBefore(alert.start)
  ) {
    errors.end = 'End time must be after the start time.';
  }

  return { errors, isValid: _.isEmpty(errors) };
}
